import { LegalLayout, Section } from "@/components/LegalLayout";
import { LEGAL } from "@/lib/legal";

export default function Cookies() {
  return (
    <LegalLayout title="Politique de cookies" testid="cookies-page"
      intro={`En vigueur au ${LEGAL.updated}. Cette politique explique l'usage des cookies et des technologies de stockage local sur Alliance Manif.`}>

      <Section title="1. Qu'est-ce qu'un cookie ?">
        <p>Un cookie est un petit fichier déposé sur votre appareil lors de la visite d'un site. On distingue aussi le « stockage local » (localStorage) du navigateur, qui conserve des préférences sans être renvoyé à un serveur.</p>
      </Section>

      <Section title="2. Notre approche : pas de pistage">
        <p>Alliance Manif <strong>n'utilise aucun cookie publicitaire ni traceur à des fins de pistage</strong>. Nous n'utilisons pas de régie publicitaire et ne revendons aucune donnée. Par défaut, aucune mesure d'audience tierce n'est activée.</p>
      </Section>

      <Section title="3. Éléments réellement utilisés">
        <p><strong>Préférences (stockage local, strictement nécessaire) :</strong></p>
        <p>• <code className="text-slate-200">am_theme</code> — mémorise votre choix de thème clair/sombre.</p>
        <p>• <code className="text-slate-200">am_notif</code> — mémorise si vous avez activé les alertes de blocage locales.</p>
        <p><strong>Service Worker (PWA) :</strong> si vous installez l'application, un service worker met en cache des ressources pour permettre un chargement plus rapide et une utilisation hors-ligne partielle. Il ne collecte aucune donnée personnelle.</p>
        <p>Ces éléments sont <strong>strictement nécessaires</strong> au bon fonctionnement du service et à la mémorisation de vos préférences ; ils ne requièrent pas de consentement préalable au sens des recommandations de la CNIL.</p>
      </Section>

      <Section title="4. Services tiers">
        <p>L'affichage de la carte (OpenStreetMap) et le géocodage (API Adresse / geo.api.gouv.fr, photon.komoot.io) s'effectuent par des appels directs à ces services, qui peuvent déposer leurs propres traceurs techniques ou recevoir votre adresse IP pour fournir le contenu demandé. Reportez-vous à leurs politiques respectives.</p>
      </Section>

      <Section title="5. Gérer et supprimer les cookies">
        <p>Vous pouvez à tout moment effacer le stockage local et les cookies via les réglages de votre navigateur (section « Confidentialité » ou « Données de navigation »). La suppression de <code className="text-slate-200">am_theme</code> ou <code className="text-slate-200">am_notif</code> réinitialisera simplement vos préférences.</p>
      </Section>

      <Section title="6. Évolution">
        <p>Si une mesure d'audience ou un service nécessitant un consentement était introduit à l'avenir, une bannière de consentement serait mise en place et cette politique mise à jour. Pour toute question : <a href={`mailto:${LEGAL.email}`} className="text-sky-400 hover:underline">{LEGAL.email}</a>.</p>
      </Section>
    </LegalLayout>
  );
}
